import cx from 'classnames'
import Styles from './ImageThumbnail.module.scss'
import { VideoThumbnailProps } from './Types'
import { useHover } from '@react-aria/interactions'
import { Checkbox } from 'blaze-ui/Checkbox/Checkbox'
import { useEffect, useState } from 'react'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { VideoDuration } from 'components/VideoDuration/VideoDuration'
import { VideoLoadingSpinner } from '../../components/VideoLoadingSpinner/VideoLoadingSpinner'

export const VideoThumbnail = ({
  video,
  onToggleSelect,
  isSelected,
  label,
  duration,
  controls = false,
  autoPlay = false,
}: VideoThumbnailProps) => {
  const { hoverProps, isHovered } = useHover({})
  const [error, setError] = useState(false)
  const [videoLoaded, serVideoLoaded] = useState(false)
  const { isMobile } = useResponsiveDesign()

  const handleSelect = () => {
    if (error) return
    onToggleSelect(video)
  }

  useEffect(() => {
    if (isSelected && error) {
      onToggleSelect(video)
    }
  }, [error, isSelected, onToggleSelect, video])

  return (
    <div
      {...hoverProps}
      className={cx(Styles.imageThumbnail, {
        [Styles.hovered]: isHovered,
        [Styles.selected]: isSelected,
        [Styles.errored]: error,
      })}
      onClick={handleSelect}
      aria-label={isSelected ? 'Selected Video' : ''}
    >
      {error ? (
        <div className={Styles.error}>Error loading video</div>
      ) : (
        <>
          <video
            src={video.preview_variant_url || video.source_url}
            controls={controls}
            autoPlay={autoPlay}
            aria-label="link video preview"
            className={cx({ [Styles.hidden]: !videoLoaded })}
            onLoadedData={() => serVideoLoaded(true)}
            onError={() => setError(true)}
            muted
            loop
          />
          <img
            alt="video thumbnail preview"
            src={video.thumbnail_url}
            className={cx({ [Styles.hidden]: !!videoLoaded })}
            onError={() => setError(true)}
          />
          {duration && !controls && <VideoDuration duration={duration} />}
          {duration && !videoLoaded && <VideoLoadingSpinner />}
        </>
      )}
      {(isSelected || isHovered) && !error && (
        <div className={Styles.checkbox}>
          <Checkbox
            color="var(--selected-fill)"
            size={isMobile ? 20 : 28}
            isSelected={isSelected}
            aria-label="Select image"
          />
        </div>
      )}
      {label && <p className={Styles.label}>{label}</p>}
    </div>
  )
}
